import React from 'react';
import { motion } from 'framer-motion';
import { Layout } from '../components/Layout';
import { CalendarIcon, ClockIcon, MapPinIcon } from 'lucide-react';
export function BookingPage() {
  return <Layout data-id="element-317">
      <section className="py-24 px-6 bg-alabaster border-b-3 border-charcoal" data-id="element-318">
        <div className="max-w-7xl mx-auto text-center" data-id="element-319">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-block bg-espresso/10 text-espresso px-4 py-2 font-bold uppercase tracking-widest text-xs mb-6" data-id="element-320">
            Schedule Now
          </motion.span>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-5xl md:text-7xl font-bold mb-8" data-id="element-321">
            Book Your{' '}
            <span className="italic font-serif font-normal text-espresso" data-id="element-322">
              Consultation
            </span>
            .
          </motion.h1>
        </div>
      </section>

      <section className="py-24 px-6 bg-white" data-id="element-323">
        <div className="max-w-4xl mx-auto" data-id="element-324">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-325">
            {/* Info */}
            <div className="space-y-8" data-id="element-326">
              <div className="p-6 border-3 border-charcoal bg-alabaster" data-id="element-327">
                <CalendarIcon className="w-8 h-8 text-espresso mb-4" data-id="element-328" />
                <h3 className="font-bold uppercase tracking-widest text-xs mb-2" data-id="element-329">
                  Availability
                </h3>
                <p className="text-sm text-charcoal/60" data-id="element-330">
                  Monday — Friday
                  <br data-id="element-331" />
                  8:00 AM — 6:00 PM
                </p>
              </div>
              <div className="p-6 border-3 border-charcoal" data-id="element-332">
                <ClockIcon className="w-8 h-8 text-espresso mb-4" data-id="element-333" />
                <h3 className="font-bold uppercase tracking-widest text-xs mb-2" data-id="element-334">
                  Duration
                </h3>
                <p className="text-sm text-charcoal/60" data-id="element-335">
                  Initial consultations typically take 45-60 minutes.
                </p>
              </div>
              <div className="p-6 border-3 border-charcoal" data-id="element-336">
                <MapPinIcon className="w-8 h-8 text-espresso mb-4" data-id="element-337" />
                <h3 className="font-bold uppercase tracking-widest text-xs mb-2" data-id="element-338">
                  Location
                </h3>
                <p className="text-sm text-charcoal/60" data-id="element-339">
                  In-home or virtual via photo analysis.
                </p>
              </div>
            </div>

            {/* Form Placeholder */}
            <div className="lg:col-span-2 border-3 border-charcoal p-10 bg-alabaster/30" data-id="element-340">
              <h2 className="text-2xl font-bold mb-8" data-id="element-341">Select a Date & Time</h2>
              <div className="space-y-6" data-id="element-342">
                <div className="grid grid-cols-2 gap-4" data-id="element-343">
                  <input type="date" className="w-full bg-white border-3 border-charcoal p-4 font-bold uppercase tracking-widest text-xs outline-none focus:border-espresso transition-colors" data-id="element-344" />
                  <select className="w-full bg-white border-3 border-charcoal p-4 font-bold uppercase tracking-widest text-xs outline-none focus:border-espresso transition-colors" data-id="element-345">
                    <option data-id="element-346">Morning (8AM - 12PM)</option>
                    <option data-id="element-347">Afternoon (12PM - 4PM)</option>
                    <option data-id="element-348">Evening (4PM - 6PM)</option>
                  </select>
                </div>
                <input type="text" placeholder="FULL NAME" className="w-full bg-white border-3 border-charcoal p-4 font-bold uppercase tracking-widest text-xs outline-none focus:border-espresso transition-colors" data-id="element-349" />
                <input type="email" placeholder="EMAIL ADDRESS" className="w-full bg-white border-3 border-charcoal p-4 font-bold uppercase tracking-widest text-xs outline-none focus:border-espresso transition-colors" data-id="element-350" />
                <textarea placeholder="PROJECT DETAILS" className="w-full bg-white border-3 border-charcoal p-4 font-bold uppercase tracking-widest text-xs outline-none focus:border-espresso transition-colors min-h-[120px]" data-id="element-351"></textarea>
                <button className="w-full bg-charcoal text-alabaster py-5 font-bold uppercase tracking-[0.2em] text-sm hover:bg-espresso transition-colors" data-id="element-352">
                  Confirm Appointment
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}